<div>

  <div *ngIf="!isFormatTypeTextLong()">
    <div style="display:inline-block; vertical-align:middle; margin-right:0.2em;" *ngIf="element.prefix">
      {{element.prefix}}
    </div>
    <div style="display:inline-block; vertical-align:middle; ">
      <div *ngIf="isFormatTypeNumber()">
        <input type="text" [id]="getInputId('number')" [attr.aria-label]="getInputLabel('number')" [formControl]="numberInput" class="input" style="width:5em; text-align:center" >
      </div>
      <div *ngIf="isFormatTypeFraction()">
        <div style="display:inline-block; vertical-align:middle;">
          <div *ngIf="element.isMixedNumber" style="display:inline-block; vertical-align:middle; margin-right:0.2em;">
            <input type="text" [id]="getInputId('whole')" [attr.aria-label]="getInputLabel('whole')" [formControl]="fractionWholeInput" class="input input-fraction"  >
          </div>
          <div style="display:inline-block; vertical-align:middle;">
            <input type="text" [id]="getInputId('numerator')" [attr.aria-label]="getInputLabel('numerator')" [formControl]="fractionNumeInput" class="input  input-fraction is-small"  >
            <div style="margin-bottom:6px; border:1px solid #333;"></div>
            <input type="text" [id]="getInputId('denominator')" [attr.aria-label]="getInputLabel('denominator')" [formControl]="fractionDenoInput" class="input  input-fraction is-small"  >
          </div>
        </div>
      </div>
      <div *ngIf="isFormatTypeTextShort()">
        <input 
          type="text" 
          class="input" 
          [id]="getInputId('short-text')"
          [attr.aria-label]="getInputLabel('short-text')"
          [formControl]="textInput" 
          [ngStyle]="{'width.em':element.maxChars*1 + 2}"
        />
      </div>
      <div *ngIf="isFormatTypeRatio()">
        <span *ngFor="let listEntry of ratioTerms; let listIndex = index;">
          <span *ngIf="listIndex !== 0" style="margin-left:0.3em; margin-right:0.3em;">:</span>
          <input type="text" class="input" [id]="getInputId('ratio', listIndex)" [attr.aria-label]="getInputLabel('ratio', listIndex)" [formControl]="listEntry" style="width:40px; vertical-align:middle; text-align:center">
        </span>
      </div>
      <div *ngIf="isFormatTypeAlgebra()" style="min-width:12em" role="group" [attr.aria-label]="getInputLabel('algebra')">
        <capture-math 
          [obj]="latexCapture" 
          prop="latexInput"
          [isManualKeyboard]="true"
          (onChange)="updateState()"
        ></capture-math>
      </div>
    </div>
    <div style="display:inline-block; vertical-align:middle; margin-left:0.2em;" *ngIf="element.suffix">
      {{element.suffix}}
    </div>
  </div>
  
  <div *ngIf="isFormatTypeTextLong()">
    <textarea 
      class="textarea is-fullwidth" 
      style="width: 24em;"
      [id]="getInputId('long-text')"
      [attr.aria-label]="getInputLabel('long-text')"
      [attr.aria-describedby]="getLongTextDescribedBy()"
      [maxlength]="element.maxChars"
      [formControl]="textInput"
    ></textarea>
    <small *ngIf="element.maxChars" [id]="getRemainingCharactersId()" class="remaining-chars" [class.is-complete]="getRemainingCharacters() == 0" aria-live="polite" >
      Remaining characters: {{getRemainingCharacters()}}
    </small>
  </div>


</div>
